var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<!-- We have to make sure the contents of the block (the live-demo directives)--><!-- are added to the DOM, so their directives will trigger--><ng-transclude>ng-hide='true'</ng-transclude><ul class=\"nav nav-tabs\"><li ng-repeat=\"demo in liveDemoBlockCtrl.demos\" ng-class=\"{active: demo.selected}\"><a ng-click=\"liveDemoBlockCtrl.selectDemo(demo)\">{{demo.name}}</a></li></ul><div class=\"demo-area\"><div ng-class=\"{ 'iframe': liveDemoBlockCtrl.iframe, 'iframe-loading': liveDemoBlockCtrl.iframeIsLoading }\" class=\"live-result\"><h6 ng-if=\"liveDemoBlockCtrl.iframe\" class=\"prose\">iframe</h6><live-demo-result></live-demo-result></div><div class=\"live-source\"><h5 class=\"area-label\">Try it out:</h5><div class=\"padded-area\"><textarea ng-model=\"liveDemoBlockCtrl.liveSource\" rows=\"{{liveDemoBlockCtrl.liveSourceNumRows}}\"></textarea></div></div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/common/components/live-demo-block.jade
 ** module id = 679
 ** module chunks = 0 1 3 4 5 6
 **/